import classNames from 'classnames';
import i18next from 'i18next';
import { times } from 'lodash-es';
import * as React from 'react';
import { useLocation } from 'react-router-dom';

interface HeaderOuterProps {
  stepMap: { [key: string]: number };
  steps: number;
  stepTitleKey: string;
}

interface SpotProps {
  index: number;
  active: boolean;
  stepTitleKey: string;
}

const Spot: React.FC<SpotProps> = (props) => {
  const classes = classNames('spot-outer', { active: props.active });

  return (
    <div className={classes}>
      <span className="spot spot-primary-outline">{props.index}</span>
      <span className="spot-label size-xs">
        {i18next.t(`${props.stepTitleKey}.step_${props.index}`)}
      </span>
    </div>
  );
};

const RegistrationFlowHeader: React.FC<HeaderOuterProps> = (props) => {
  const location = useLocation();
  const currentStepIndex = props.stepMap[location.pathname];

  return (
    <div className="navbar navbar-light navbar-full m-b-md aya-navbar p-y-0 xs-down-p-x-0">
      <div className="p-x-0">
        <div className="aya-navbar-brand-logo xs-down-p-x">
          <svg className="icon">
            <use xlinkHref="#other-sapuri" />
          </svg>
        </div>
        <div className="progress-spots text-center">
          {times(props.steps, (i) => i + 1).map((index) => (
            <Spot
              key={index}
              index={index}
              active={index === currentStepIndex}
              stepTitleKey={props.stepTitleKey}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default RegistrationFlowHeader;
